import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxCashOutEdit = cashBoxRegister("CashBoxCashOutEdit")

export default CashBoxCashOutEdit
